/**
 * @fileoverview SpreadsheetSpec — shared contract for agent-authored
 * downloadable spreadsheets. Used as the createSpreadsheet tool inputSchema
 * and by the frontend workbook builder. Depends only on zod.
 */
import { z } from "zod";

const CellSchema = z.union([z.string(), z.number(), z.null()]);

export const SpreadsheetSpecSchema = z.object({
  /** Base file name, no extension. */
  filename: z.string().min(1),
  sheets: z
    .array(
      z.object({
        name: z.string().min(1),
        columns: z
          .array(z.object({ key: z.string().min(1), label: z.string().min(1) }))
          .min(1),
        rows: z.array(z.record(z.string(), CellSchema)),
      }),
    )
    .min(1),
});

export type SpreadsheetSpec = z.infer<typeof SpreadsheetSpecSchema>;
